import React from "react";
import Template from "../../../../templates/Crew/Bunkering/Create/Complete";
import Default from "../../../../layouts/DefaultCrew";

const Complete = (): React.ReactElement => {
  return (
    <Default title="" selectedTitle={"Bunkering"}>
      <Template />
    </Default>
  );
};

export default Complete;
